if (!customElements.get('selling-plan-select')) {
  customElements.define(
    'selling-plan-select',
    class SellingPlanSelect extends HTMLElement {
      constructor() {
        super();
        this.lineItemId = this.dataset.itemId;
        this.lineItemQuantity = this.dataset.quantity;
        this.firstSellingPlanId = this.dataset.firstPlanId;
        this.selectedPlanId = this.dataset.currentPlanId;
        this.checkoutButton = document.querySelector('#CartDrawer-Checkout');
        this.cartItem = this.closest('.cart-item');
        this.loadingSpinner = this.cartItem.querySelector('.price-loading-spinner');

        this.options = this.querySelectorAll('.selling-plan-option');
        this.subscriptionInput = this.querySelector('#selling-plan-select');

        this.deliveryFrequencySelect = this.querySelector('#frequency_delivery_select');

        this.debouncedUpdatePlan = debounce((args) => {
          this.updateSellingPlan(args);
        }, 0);

        this.debounceAndDisableUpdatePlan = () => {
          this.checkoutButton.disabled = true;
          this.debouncedUpdatePlan();
        };
      }

      connectedCallback() {
        this.options.forEach((option) => {
          option.addEventListener('click', this.selectPlan.bind(this));
        });

        this.deliveryFrequencySelect.addEventListener('change', this.selectDeliveryFrequency.bind(this));
      }

      selectPlan(e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.target.tagName != 'INPUT' && e.target.tagName != 'LABEL') return;

        const container = e.target.closest('.selling-plan-option');
        const childInput = container.querySelector('input');

        childInput.checked = true;

        if (childInput.id == 'selling-plan-select') {
          if (this.selectedPlanId) {
            this.checkoutButton.disabled = false;
            return;
          }

          this.selectedPlanId = this.firstSellingPlanId;
          this.debounceAndDisableUpdatePlan();
        } else {
          this.selectedPlanId = '';
          this.debounceAndDisableUpdatePlan();
        }
      }

      selectDeliveryFrequency(e) {
        e.preventDefault();
        e.stopPropagation();

        if (!this.subscriptionInput?.checked) {
          this.subscriptionInput.checked = true;
        }

        const value = e.target.value;

        this.selectedPlanId = value;
        this.dataset.firstPlanId = value;

        this.debounceAndDisableUpdatePlan();
      }

      updateSellingPlan() {
        this.checkoutButton.disabled = true;
        this.loadingSpinner.classList.remove('hidden');
        const selectedPlanId = this.selectedPlanId;

        fetch(`${routes.cart_change_url}?section_id=cart-drawer`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: this.lineItemId,
            quantity: this.lineItemQuantity,
            selling_plan: selectedPlanId ? Number(selectedPlanId) : null,
          }),
        })
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => (this.checkoutButton.disabled = false));
      }
    }
  );
}
